import loadable from '@loadable/component';
import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {showSheet} from '../../../../../actions/SheetActions';
import CustomBottomSheet from '../../../../../components/bottom-sheet';
import Spacer from '../../../../../components/spacer/Spacer.component';
import {isWeb} from '../../../../../constants';
import {selectrootsheettype} from '../../../../../selectors/SheetSelector';
import {selecetusertype} from '../../../../../selectors/User';
import StepScreen from '../step-screen/StepScreen.component';
import styles from './NationalPendingSheet.style';
const SVG = loadable(() => import('../../../../../imports/svg'));

export default function NationalPendingSheet() {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const bottomSheetRef = useRef(null);
  const {sheetId} = useSelector(state => selectrootsheettype(state));
  const {userStatus} = useSelector(state => selecetusertype(state));
  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);

  useEffect(() => {
    switch (sheetId) {
      case 'nationalCardPending':
        openHandler();
        break;
      default:
        closeHandler();
        break;
    }
  }, [sheetId]);

  useEffect(() => {
    if (userStatus !== 'profile_submitted') {
      closeHandler();
    }
  }, [userStatus]);

  function openHandler() {
    setIsBottomSheetVisible(true);
    if (isWeb) return;
    bottomSheetRef.current?.expand();
  }

  function closeHandler() {
    setTimeout(() => {
      setIsBottomSheetVisible(false);
    }, 400);
    dispatch(showSheet({sheetId: ''}));
    switch (isWeb) {
      case true:
        bottomSheetRef?.current?.snapTo(() => 0);
        break;
      case false:
        bottomSheetRef.current?.close();
        break;
      default:
        break;
    }
  }

  function onRequestClose() {
    dispatch(showSheet({sheetId: ''}));
  }

  if (isBottomSheetVisible) {
    return (
      <CustomBottomSheet
        onClose={onRequestClose}
        ref={bottomSheetRef}
        enablePanDownToClose={isWeb ? undefined : true}
        snapPoints={isWeb ? ({minHeight}) => [1, minHeight] : [486]}
        defaultSnap={isWeb ? 486 : undefined}
        onSpringEnd={
          isWeb
            ? () => {
                if (bottomSheetRef?.current?.height < 2) {
                  dispatch(showSheet({sheetId: ''}));
                }
              }
            : undefined
        }
        open={true}
        isScrollView={isWeb ? undefined : true }
        scrollViewStyle={isWeb ? undefined :styles.scroll}>
        <StepScreen
          buttonProps={{
            title: t('i_realized'),
            containerStyle: styles.button,
            onPress: closeHandler,
          }}
          hideHeader
          activeIndex={1}
          isActiveIndexPass
          numberOfPoints={3}
          icon={'userId'}
          iconSize={24}
          title={t('national_card_photo_is_waiting')}
          descriptionStyle={styles.description}>
          <SVG name={'pending'} width={200} height={200} />
          <Spacer />
        </StepScreen>
      </CustomBottomSheet>
    );
  } else {
    return null;
  }
}
